import WeakRefSet from 'src/utils/WeakRefSet'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */

// This helper is used to track an app modes layout instance count so we can detect memory leaks
// To use this, trackLayoutMounted will be called when a layout is mounted
// We don't need to worry about tracking unmounted as we only ever expect to have one layout instance at a time so this is unnecessary
export default async ({ app }) => {
  // Using a WeakRefSet allows any objects retained in the set to be garbage collected
  // This is a trick to track the number of instances that are still in memory without leaking them
  const weakRefSet = new WeakRefSet()

  const vueLayoutCountTracker = {
    totalCreations: 0 // We track the number of creations so we can compare it to the number of instances that are still in memory
  }

  function trackLayoutMounted (component) {
    weakRefSet.add(component)
    vueLayoutCountTracker.totalCreations++
  }

  // .items() will only return objects that are still in memory
  function getInstanceCount () {
    return weakRefSet.items().length
  }

  vueLayoutCountTracker.trackLayoutMounted = trackLayoutMounted
  vueLayoutCountTracker.getInstanceCount = getInstanceCount

  app.config.globalProperties.$vueLayoutCountTracker = vueLayoutCountTracker
}
